import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardShell from "@/components/DashboardShell";
import { CANDIDATE_NAV } from "./nav";
import api from "@/lib/api";
import { Bookmark, MapPin, Briefcase } from "lucide-react";

export default function SavedJobs() {
  const [jobs, setJobs] = useState(null);
  useEffect(() => { api.get("/me/saved-jobs").then((r) => setJobs(r.data)).catch(() => setJobs([])); }, []);

  return (
    <DashboardShell nav={CANDIDATE_NAV}>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-5">Saved Jobs</h1>
      {jobs === null ? <div className="h-40 bg-white rounded-xl animate-pulse" /> : jobs.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-xl border border-slate-200"><Bookmark className="w-10 h-10 text-slate-300 mx-auto mb-3" /><p className="text-slate-500">No saved jobs yet.</p></div>
      ) : (
        <div className="space-y-3">
          {jobs.map((j) => (
            <Link key={j.job_id} to={`/jobs/${j.job_id}`} className="block bg-white rounded-xl border border-slate-200 p-5 hover:border-[#D96B27] transition-colors">
              <h3 className="font-display font-semibold text-slate-900">{j.title}</h3>
              <div className="flex flex-wrap gap-x-5 gap-y-1 mt-2 text-sm text-slate-600">
                <span>{j.company_name}</span>
                <span className="flex items-center gap-1"><MapPin className="w-4 h-4 text-slate-400" />{j.location}</span>
                <span className="flex items-center gap-1"><Briefcase className="w-4 h-4 text-slate-400" />{j.min_experience}-{j.max_experience} yrs</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </DashboardShell>
  );
}
